import type {SVGProps} from 'react';
import {forwardRef} from 'react';

export const NotificationBellOffIcon = forwardRef<SVGSVGElement, SVGProps<SVGSVGElement>>((props, ref) => (
    <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='currentColor' {...props} ref={ref}>
        <path d='M14.74 14.306 1.594 1.152.74 2l3.147 3.147a4.65 4.65 0 0 0-.553 2.186v4L2 12.666v.666h10.074l1.82 1.82.846-.846ZM4.667 11.999V7.332c0-.406.073-.806.227-1.18L10.74 12H4.667Zm2 2h2.667a1.333 1.333 0 1 1-2.667 0ZM5.527 3.392c.353-.226.74-.393 1.14-.533v-.193a1.333 1.333 0 0 1 2.667 0v.193a4.66 4.66 0 0 1 3.333 4.473v3.2L11.334 9.2V7.332A3.333 3.333 0 0 0 8 4c-.52 0-1.033.133-1.493.373l-.98-.98Z' />
    </svg>
));
